export function Close() {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        // eslint-disable-next-line max-len
        d="M13.4844 11.7031L9.53125 7.75L13.4844 3.83984C14.1289 3.15234 14.1289 2.07812 13.4844 1.39062C12.7969 0.746094 11.7227 0.746094 11.0352 1.39062L7.125 5.34375L3.17188 1.39062C2.48438 0.746094 1.41016 0.746094 0.722656 1.39062C0.078125 2.07812 0.078125 3.15234 0.722656 3.83984L4.67578 7.75L0.722656 11.7031C0.078125 12.3906 0.078125 13.4648 0.722656 14.1523C1.41016 14.7969 2.48438 14.7969 3.17188 14.1523L7.125 10.1992L11.0352 14.1523C11.7227 14.7969 12.7969 14.7969 13.4844 14.1523C14.1289 13.4648 14.1289 12.3906 13.4844 11.7031Z"
        fill="#525266"
      />
    </svg>
  );
}
